import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ client_id, authorities, user_name, exp }) {
    this.clientId = client_id // eslint-disable-line camelcase
    this.authorities = authorities
    this.email = user_name // eslint-disable-line camelcase
    this.expiration = exp
  }

  // get isAdmin () {
  //   return this.authorities
  // }
}
